export default "__VITE_ASSET__CyW2O2iV__"